import { UserRoleEnum } from '@enums/user-role.enum';

export const EventConstant = {
    assignLegEvent: "assignLegEvent",
    incomingMessageCountEvent: "incomingMessageCountEvent",
    fetchMessageEvent: "fetchMessageEvent",
    changeLegStatusEvent: "changeLegStatusEvent",
    removeLegAssignmentEvent: "removeLegAssignmentEvent",
    serviceRequestCreatedEvent: "serviceRequestCreatedEvent",
    driverShiftEvent: "driverShiftEvent",
    vendorAssignmentRequestEvent: "vendorAssignmentRequestEvent",
    serviceRequestStatusUpdateEvent: "ServiceRequestStatusUpdateEvent",
    legDeletionEvent: "LegDeletionEvent",
    internalGroupChatSendMessageEvent: "InternalGroupChatSendMessageEvent",
    createGroupEvent: "CreateGroupEvent",
    deleteGroupEvent: "DeleteGroupEvent",
    updateLegTimeStampEvent: "UpdateLegTimeStampEvent",
    customersRequestChangeEvent: "CustomersRequestChangeEvent",
    customersPendingRequestsChangeEvent: "CustomersPendingRequestsChangeEvent",
    notificationsUpdateEvent: 'NotificationsUpdateEvent',
    serviceRequestApprovedOrRejectedEvent: 'ServiceRequestApprovedOrRejectedEvent',
    internalTripNotificationEvent: "InternalNotificationEvent",
    itineraryReadyEvent: "ItineraryReadyEvent",
    serviceRequestFlagEvent: "SRFlagEvent",
};

export const serverTimeoutInMilliseconds: number = 240000; //4 minutes
export const maxRetries: number = 3;

export const EventMap: string[] = [
  EventConstant.assignLegEvent,
  EventConstant.incomingMessageCountEvent,
  EventConstant.fetchMessageEvent,
  EventConstant.changeLegStatusEvent,
  EventConstant.removeLegAssignmentEvent,
  EventConstant.serviceRequestCreatedEvent,
  EventConstant.driverShiftEvent,
  EventConstant.vendorAssignmentRequestEvent,
  EventConstant.serviceRequestStatusUpdateEvent,
  EventConstant.legDeletionEvent,
  EventConstant.internalGroupChatSendMessageEvent,
  EventConstant.createGroupEvent,
  EventConstant.deleteGroupEvent,
  EventConstant.updateLegTimeStampEvent,
  EventConstant.customersRequestChangeEvent,
  EventConstant.customersPendingRequestsChangeEvent,
  EventConstant.notificationsUpdateEvent,
  EventConstant.serviceRequestApprovedOrRejectedEvent,
  EventConstant.internalTripNotificationEvent,
  EventConstant.itineraryReadyEvent,
];

export const RoleEventMap: { [key: string]: string[] } = {
    [UserRoleEnum.EXECUTIVE_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.serviceRequestFlagEvent
    ],
    [UserRoleEnum.COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.driverShiftEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.customersPendingRequestsChangeEvent,
        EventConstant.internalTripNotificationEvent,
        EventConstant.serviceRequestFlagEvent
    ],
    [UserRoleEnum.MANAGEMENT]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.customersPendingRequestsChangeEvent,
        EventConstant.internalTripNotificationEvent,
        EventConstant.serviceRequestFlagEvent
    ],
    [UserRoleEnum.DRIVER]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent
    ],
    [UserRoleEnum.ACCOUNTING]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
    ],
    [UserRoleEnum.INTERNAL_READONLY]: [
        EventConstant.changeLegStatusEvent,
    ],
    [UserRoleEnum.CUSTOMER_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.customersRequestChangeEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.notificationsUpdateEvent,
        EventConstant.itineraryReadyEvent,
    ],
    [UserRoleEnum.CUSTOMER_COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.customersRequestChangeEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.notificationsUpdateEvent,
        EventConstant.itineraryReadyEvent,
    ],
    [UserRoleEnum.VENDOR_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.vendorAssignmentRequestEvent
    ],
    [UserRoleEnum.VENDOR_COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.vendorAssignmentRequestEvent
    ],
    [UserRoleEnum.VENDOR_DRIVER]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent
    ],
};
